/**
 * react-navigation linking config for Rinsepay.
 *
 * Derived from the screen registry in ./screens.  The prefix list
 * covers every URL host the app should recognize as a deep link:
 *
 *   - rinsepay://          — custom URI scheme for in-app links (both
 *                            debug and release builds)
 *   - https://rinsepay.app         — Universal Links / App Links for
 *                                    the PROD apex
 *   - https://m.rinsepay.app       — PROD QR landing page host
 *   - https://rinsepay.design      — dev droplet apex (debug builds
 *                                    ONLY use this via AndroidManifest
 *                                    intent filters; release builds
 *                                    also declare it here so a user
 *                                    poking around never hits "Open in
 *                                    browser" by surprise while we're
 *                                    still iterating on the dev env)
 *   - https://m.rinsepay.design    — dev QR landing host
 *
 * `getInitialURL` is left to react-navigation's default (pull from
 * Linking or from window.location on web) which is correct for both
 * native deep-link cold-starts and web page loads.
 */
import type { LinkingOptions } from '@react-navigation/native';
import type { ParamListBase } from '@react-navigation/native';
import { SCREENS } from './screens';

const screenPathMap: Record<string, string> = SCREENS.reduce(
  (acc, s) => { acc[s.name] = s.path; return acc; },
  {} as Record<string, string>,
);

export const linking: LinkingOptions<ParamListBase> = {
  prefixes: [
    'rinsepay://',
    'https://rinsepay.app',
    'https://m.rinsepay.app',
    'https://rinsepay.design',
    'https://m.rinsepay.design',
  ],
  config: {
    screens: screenPathMap,
  },
};
